module.exports = __webpack_public_path__ + "static/media/1b.b08b4fc4.jpg";